import React from 'react'
import styled from "styled-components"
import Stack from "parsley-core/src/components/Stack/Stack"

const ContentDetail = props => (
	<Stack className={`${props.className}`}>
		{props.children}
	</Stack>
)

const ContentDetailStyle = styled(ContentDetail)`
  p {
    max-width: ${props => (props.maxWidth ? props.maxWidth : '80ch')};
  }
  
	dt {
	  font-weight:bold;
	}
  dd{
	margin-bottom:var(--s-3);
  }
  h2 + *,h3 + * {
	margin-top:var(--s-3);
  }
  & > ul {
    list-style:none;
  }
  & > ul:not(.grid-list) > li {
    padding-left:var(--s2);
    position:relative;

    &::before {
      content:'';
      position:absolute;
      left:var(--s-4);
      top:var(--s-3);
      display:block;
      width:var(--s-3);
      height:var(--s-3);
      border-radius:50%;
      border:calc(.75*var(--s-5)) solid ${props => (props.borderColor ? props.borderColor : 'var(--color-tertiary)')};
      background-color:${props => (props.borderColor ? props.borderColor : 'var(--color-tertiary)')};
    }
  }
  & > ol {
    list-style: decimal;
    padding:0 0 0 var(--s1);

    & > li {
      margin: var(--border-medium) 0;

      &::marker {
        color:var(--color-primary);
      }
    }

  }
`

export default ContentDetailStyle